import * as React from 'react';

import {useHistory, useLocation} from 'react-router-dom';

import {animateScroll as scroll, scroller} from 'react-scroll';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import Sidebar from '@app/components/UI/Sidebar/Sidebar';

import VetTesCard from '@app/components/UI/VetTesCard/VetTesCard';
import VetTesModal from '@app/components/Pages/VetTestimonials/VetTesModal';
import {rest} from '@app/components/Api';
import {ListOption, StateListOption, VetListOption} from '@app/objects/SidebarProps';

import {VetTestimonialsRes} from '@app/objects/VetTestimonialsRes';
import {StatesListItem} from '@app/objects/StatesListItem';
import {Veterinarian} from '@app/objects/Veterinarian';
import {transformStateList, transformVetList} from '@app/components/LocalCommon/Utils/transformList';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import TestimonialCardModal from '@app/components/Pages/VetTestimonials/TestimonialCardModal';
import {bodyOverflowRemove, bodyOverflowTransform} from '@app/components/LocalCommon/Utils/bodyOverflowTransform';
import {navItems} from '@app/components/Pages/AboutUs/AboutUsContent';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

import '@app/scss/components/vetTestimonials.scss';

const VetTestimonials = () => {
	const mustHeadText = 'There is no exercise better for the heart than reaching down and lifting people up.';

	const [modalVisible, setModalVisible] = React.useState<boolean>(false);
	const [currentIndex, setCurrentIndex] = React.useState<number>(0);
	const [navCollapse, setNavCollapse] = React.useState<boolean>(false);
	const [resTestimonials, setResTestimonials] = React.useState<VetTestimonialsRes[]>([]);
	const [offset, setOffset] = React.useState<number>(0);
	const [cardsCount, setCardsCount] = React.useState<number>(4);
	const [stateList, setStateList] = React.useState<StatesListItem[]>([]);
	const [stateSelected, setStateSelected] = React.useState<string>('');
	const [vetIdList, setVetIdList] = React.useState<Veterinarian[]>([]);
	const [vetId, setVetId] = React.useState<string>('');
	const [vetNameList, setVetNameList] = React.useState<Veterinarian[]>([]);
	const [vetName, setVetName] = React.useState<string>('');
	const [vetNameShort, setVetNameShort] = React.useState<string>('');
	const [vetFieldValue, setVetFieldValue] = React.useState<string>('');
	const stateListOptions: ListOption[] = [];
	const vetListOptions: ListOption[] = [];
	const vetNameListOptions: ListOption[] = [];
	const [totalCount, setTotalCount] = React.useState(0);
	const [sent, setSent] = React.useState<boolean>(false);
	const [tesModalVisible, setTesModalVisible] = React.useState(false);
	const history = useHistory();
	const location = useLocation();

	const openModal = () => {
		setModalVisible(true);
		setSent(false);
	};

	const onSetIssue = (index) => {
		setCurrentIndex(index);
	};

	const addCards = () => {
		setOffset(offset + 4);
	};

	const onSubmit = () => {
		setModalVisible(true);
	};

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
		bodyOverflowTransform(true);
		return function cleanOverflow() {
			bodyOverflowRemove();
		};
	}, []);

	React.useEffect(() => {
		if (!location?.state?.navCollapse) {
			if (location?.state?.vetId) {
				setStateSelected(location.state.state);
				setVetId(location.state.vetId);
				setVetFieldValue(location.state.name);
			}
		} else {
			if (location?.state?.name) {
				setVetName(location.state.name);
			}
		}
	}, []);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setNavCollapse(true);
			} else {
				setNavCollapse(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	React.useEffect(() => {
		rest.get<List<VetTestimonialsRes>>(
			`v1/testimonials/
			${stateSelected}?count=${cardsCount}&veterinarianId=${vetId}&veterinarianName=${vetName.substring(0, 4) === 'Dr. ' ? vetName.slice(4) : vetName}`)
			.then((res) => {
				setResTestimonials(res.list);
				// @ts-ignore
				setTotalCount(res.count);
			}
		);
	}, [stateSelected, vetId, vetName]);

	React.useEffect(() => {
		offset > 0 && rest.get<List<VetTestimonialsRes>>(
			`v1/testimonials/
			${stateSelected}?offset=${offset}&count=${cardsCount}&veterinarianId=${vetId}&veterinarianName=${vetName.substring(0, 4) === 'Dr. ' ? vetName.slice(4) : vetName}`)
			.then((res) => {
				setResTestimonials([...resTestimonials, ...res.list]);
				// @ts-ignore
				setTotalCount(res.count);
			}
		);
	}, [offset]);

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states').then(res => setStateList(res.list));
	}, []);

	React.useEffect(() => {
		rest.get<List<Veterinarian>>(`v1/veterinarians?count=300&name=${vetNameShort}`).then(res => setVetNameList(res.list));
	}, [vetNameShort]);

	React.useEffect(() => {
		const check = stateList.find(state => (
			state.name === stateSelected
		));
		check?.veterinarians ?
			rest.get<List<Veterinarian>>(`v1/veterinarians/${stateSelected}?count=100&name=${vetFieldValue}`).then(res => setVetIdList(res.list)) :
			rest.get<List<Veterinarian>>(`v1/veterinarians/?name=${vetFieldValue}`).then(res => setVetIdList(res.list));

	}, [vetFieldValue, stateSelected]);

	transformStateList(stateList, stateListOptions);
	transformVetList(vetIdList, vetListOptions);
	transformVetList(vetNameList, vetNameListOptions);
	const slider = React.useRef<any>();

	return (
		<div className="vet-testimonials" id="vet-testimonials">
			<Musthead
				title="Testimonials for Lap of Love Veterinarians"
				imageSrc={require('@app/content/vet_tes_musthead.png')}
				imageAlt="Senior dog veterinary hospice"
				text={mustHeadText}
				quoteAuthor={'John Holmes'}
				buttonText="Submit a testimonial"
				btnPath="/"
				onBtnClick={openModal}

			/>
			<div className="vet-testimonials__body">
				<Sidebar
					searchFieldName="vetByName"
					searchFieldPlaceHolder="Search testimonials by vet name"
					onSetIssue={onSetIssue}
					currentIndex={currentIndex}
					navCollapse = {false}
					topics={null}
					withSubmit={true}
					submitCaption="Submit a testimonial"
					setStateSelected={setStateSelected}
					stateSelected={stateSelected}
					vetId={vetId}
					setVetId={setVetId}
					setVetName={setVetName}
					setVetNameShort={setVetNameShort}
					vetNameShort={vetNameShort}
					vetFieldValue={vetFieldValue}
					setVetFieldValue={setVetFieldValue}
					stateListOptions={stateListOptions}
					vetListOptions={vetListOptions}
					vetNameListOptions={vetNameListOptions}
					setCardsCount={setCardsCount}
					onSubmit={onSubmit}
					initCardsCount={4}
					vetName={vetName}
				/>
				<div className="vet-testimonials__content">
					{
						resTestimonials && resTestimonials.map((item, index) => (
							<VetTesCard
								tes = {item}
								key = {item.id}
								navCollapse = {navCollapse}
								setTesModalVisible={setTesModalVisible}
						/>
						))
					}
					{   offset < totalCount - 4 &&
						<button className="btn btn-lg btn-secondary btn-load-more" onClick = {addCards}>
							Load more testimonials
						</button>
					}
				</div>
			</div>
			<VetTesModal
				modalVisible={modalVisible}
				setModalVisible = {setModalVisible}
				sent={sent}
				setSent={setSent}

			/>
			<TestimonialCardModal
				tesModalVisible={tesModalVisible}
				setTesModalVisible={setTesModalVisible}
				outerModalProps={resTestimonials}
			/>

		</div>
	);
};

export default withSeo(VetTestimonials, state => state.testimonialsPage, 'testimonialsPage', 'veterinarian-testimonials');